import { CardId } from './types';

export const DASHBOARD_CARD_TITLE_KEYS: Partial<Record<CardId, string>> = {
  totalEntities: 'dashboard.card-title-total-entities',
  totalReturns: 'dashboard.card-title-my-open-returns',
  notStarted: 'main.notStarted',
  pendingTasks: 'dashboard.card-title-team-returns',
  awaitingReview: 'dashboard.card-title-awaiting-review',
  submittedThisMonth: 'dashboard.card-title-submitted-month',
  tasksByStatus: 'dashboard.card-title-tasks-by-status',
  returnsByDueDate: 'dashboard.card-title-returns-by-due-date',
  calendar: 'dashboard.card-title-calendar',
  typesOfReturns: 'dashboard.card-title-type-of-returns',
  yourRoleInReturns: 'dashboard.card-title-your-role-in-returns',
  vatNumberChecker: 'navigation.vat-number-checker',
  teamAllocation: 'dashboard.team-allocation',
  submittedReturnsChart: 'dashboard.total-returns-submitted',
  timeToSubmit: 'dashboard.time-to-submit',
};

export const DASHBOARD_CARD_DESCRIPTION_KEYS: Partial<Record<CardId, string>> =
  {
    totalEntities: 'dashboard.card-description-total-entities',
    totalReturns: 'dashboard.card-description-my-open-returns',
    notStarted: 'dashboard.card-description-not-started',
    pendingTasks: 'dashboard.card-description-team-returns',
    awaitingReview: 'dashboard.card-description-awaiting-review',
    submittedThisMonth: 'dashboard.card-description-submitted-month',
    tasksByStatus: 'dashboard.card-description-tasks-by-status',
    returnsByDueDate: 'dashboard.card-description-returns-by-due-date',
    calendar: 'dashboard.card-description-calendar',
    typesOfReturns: 'dashboard.card-description-type-of-returns',
    yourRoleInReturns: 'dashboard.card-description-your-role-in-returns',
    vatNumberChecker: 'dashboard.card-description-vat-number-checker',
    teamAllocation: 'dashboard.card-description-team-allocation',
    submittedReturnsChart: 'dashboard.card-description-submitted-returns-chart',
    timeToSubmit: 'dashboard.card-description-time-to-submit',
  };
